import React from 'react';
import {
  SectionHeading,
  StyledAsterisksText,
  FormSection,
} from '@/shared/styles/styledComponents/editProfileForm';
import { GalleryImages } from '@/shared/types/stylist';
import useBreakpoint from '@/shared/hooks/useBreakpoint';
import GalleryLayout from '@/shared/components/GalleryLayout';
import { sand } from '@/shared/styles/colors';

interface PortfolioSectionProps {
  galleryImages: GalleryImages;
  selectLandscapeImage: () => Promise<void>;
  selectPortraitImage: (index: number) => Promise<void>;
  addPortraitImage: () => Promise<void>;
}

const PortfolioSection: React.FC<PortfolioSectionProps> = ({
  galleryImages,
  selectLandscapeImage,
  selectPortraitImage,
  addPortraitImage,
}) => {
  const { isDesktop } = useBreakpoint();

  return (
    <FormSection isDesktop={isDesktop} marginBottom={70}>
      <SectionHeading isDesktop={isDesktop}>Portfolio</SectionHeading>
      <StyledAsterisksText>Gallery Preview*</StyledAsterisksText>
      <GalleryLayout
        galleryImages={galleryImages}
        onSelectLandscapeImage={selectLandscapeImage}
        onSelectPortraitImage={selectPortraitImage}
        onAddPortraitImage={addPortraitImage}
        isDesktop={isDesktop}
        backgroundColor={sand}
      />
    </FormSection>
  );
};

export default PortfolioSection;
